import { AppConfigService } from "../services/app-config.service";

interface EndpointFn {
  (endpoint: string): string;
  (endpoint: string, baseurl?: string): string;
}

const endpoint: EndpointFn = (param1: string, param2?: string) => {
  const baseurl = !!param2 ? param2 : AppConfigService.settings.baseUrl;
  const uri = param1;

  return baseurl + uri;
};

function ActionLink(actionLink: string) {
  return endpoint(actionLink);
}

function IsAuthenticated() {
  return endpoint(`/authentication/is-authenticated`);
}

function LoginUri() {
  return endpoint(`/authentication/signin?returnUrl=${window.location.origin}`);
}

function LogoutUri() {
  return endpoint(`/authentication/signout`);
}

function UserInformation() {
  return endpoint(`/authentication/userinformation`);
}

function SurveyCampaigns(id?: string) {
  return endpoint(`/v1/surveycampaigns/${id??""}`);
}

function CloseSurveyCampaign(id: string) {
  return endpoint(`/v1/surveycampaigns/${id}/close`);
}

function RawSoundingData(surveyCampaingId: string, soundingType: string) {
  return endpoint(`/v1/surveycampaigns/${surveyCampaingId}/soundings/rawdata/${soundingType}`);
}

function UploadRawSoundingData(surveyCampaingId: string, soundingType: string) {
  return endpoint(`/v1/surveycampaigns/${surveyCampaingId}/soundings/rawdata/${soundingType}/upload`);
}

function ValidatingSoundingData(surveyCampaingId: string) {
  return endpoint(`/v1/surveycampaigns/${surveyCampaingId}/soundings/validatingdata`);
}

function ProcessedData(surveyCampaignId: string) {
  return endpoint(`/v1/surveycampaigns/${surveyCampaignId}/soundings/processeddata`);
}

function ProcessedDataRequestDownloadPath(surveyCampaignId: string) {
  return endpoint(`/v1/surveycampaigns/${surveyCampaignId}/soundings/processeddata/download`);
}

function ProcessedDataDownloadFullLink(downloadRelativeUrlWithToken: string) {
  return endpoint(downloadRelativeUrlWithToken);
}

function ValidatingMeasurement(surveyCampaignId: string) {
  return endpoint(`/v1/measurements/validatingdata/${surveyCampaignId}`);
}

function ValidateMeasurements(surveyCampaignId: string) {
  return endpoint(`/v1/measurements/validate/${surveyCampaignId}`);
}

function ValidatingDataDetail(surveyCampaignId: string, locationId: string) {
  return endpoint(`/v1/measurements/validatingdata/${surveyCampaignId}/${locationId}`);
}

function ProcessMeasurements(surveyCampaignId: string) {
  return endpoint(`/v1/measurements/process/${surveyCampaignId}`);
}

function TideGraphSourceUrl(dateFrom: string, dateTo: string, locationCode: string) {
  return endpoint(`/v1/tides/${dateFrom}/${dateTo}/${locationCode}/graph.png`);
}

export default {
  ActionLink,
  IsAuthenticated,
  LoginUri,
  LogoutUri,
  UserInformation,
  SurveyCampaigns,
  CloseSurveyCampaign,
  RawSoundingData,
  UploadRawSoundingData,
  ValidatingSoundingData,
  ProcessedData,
  ProcessedDataRequestDownloadPath,
  ProcessedDataDownloadFullLink,
  ValidatingMeasurement,
  ValidateMeasurements,
  ValidatingDataDetail,
  ProcessMeasurements,
  TideGraphSourceUrl
};
